import { useLocalstorageState } from 'rooks'
import { useContext } from 'react'
import { UpdateUserDocument } from '@vendia/control-plane-api'
import analytics, { EVENTS } from 'src/utils/analytics'
import { sendLeadInfoToHubSpot } from '../analytics/plugins/enrich-hubspot'
import { authContext } from 'src/utils/auth/auth-context'
import useControlPlaneApi from './use-control-plane-api'
import useGetCurrentVendiaUserQuery from './use-current-vendia-user-query'

export type QualificationData = {
  jobTitle: string
  company: string
  mcpExperience: string
}

const STORAGE_KEY_PREFIX = 'mcp_user_qualification_info'

export const useQualification = () => {
  const { auth } = useContext(authContext)
  const client = useControlPlaneApi()
  const { getCurrentVendiaUserQuery } = useGetCurrentVendiaUserQuery()
  const currentUser = getCurrentVendiaUserQuery?.data?.getUser
  const [isQualificationInfoComplete, setIsQualificationInfoComplete] = useLocalstorageState<boolean>(
    `${STORAGE_KEY_PREFIX}_${currentUser?.userId ?? 'unknown'}`,
    false,
  )

  const completeQualificationInfo = async (data: QualificationData) => {
    // Call updateUser mutation to persist qualification data to backend
    if (currentUser?.userId) {
      await client.graphqlFetch({
        query: UpdateUserDocument,
        variables: {
          userId: currentUser.userId,
          input: {
            firstName: currentUser.firstName,
            lastName: currentUser.lastName,
            company: data.company,
            jobRole: data.jobTitle,
            mcpExperience: data.mcpExperience,
          },
        },
      })
    }

    setIsQualificationInfoComplete(true)

    if (auth.email) {
      try {
        await sendLeadInfoToHubSpot(auth.email, {
          company: data.company,
          job_function: data.jobTitle,
        })
      } catch (e) {
        console.error('Failed to send lead info to HubSpot', e)
      }
    }

    analytics.track(EVENTS.USER_QUALIFICATION_INFO_COMPLETED, {
      jobTitle: data.jobTitle,
      company: data.company,
      mcp_experience: data.mcpExperience,
    })
  }

  return {
    isQualificationInfoComplete,
    completeQualificationInfo,
  }
}
